import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CardVerificationFormService {
  generateBodyData(data: any, dataBody: any): any[] {
    const { current_data, revision_data, previous_data } = data;
    return dataBody
      .filter((val: any) => val.key)
      .map((val: any) => (val.key === 'map' ? this.createMapData(val, current_data, revision_data) : this.createFieldData(val, current_data, revision_data, previous_data)));
  }

  private createMapData(val: any, current_data: any, revision_data: any): any {
    const mapData = {
      ...val,
      map: {
        long: +current_data.longitude,
        lat: +current_data.latitude,
        label: current_data.name,
        description: current_data.address,
      },
    };

    if (revision_data?.longitude && revision_data.latitude) {
      mapData.map_revision = {
        long: +revision_data.longitude,
        lat: +revision_data.latitude,
        label: revision_data.name,
        description: revision_data.address,
      };
    }

    return mapData;
  }

  private createFieldData(val: any, current_data: any, revision_data: any, previous_data: any): any {
    const updatedVal = { ...val };
    const dataSource = this.selectDataSource(previous_data, current_data);

    for (const key in dataSource) {
      if (Object.prototype.hasOwnProperty.call(dataSource, key) && val.key === key) {
        updatedVal.value = dataSource[key as keyof typeof dataSource];
        updatedVal.revision_value = revision_data?.[key as keyof typeof dataSource] || undefined;
      }
    }

    return updatedVal;
  }

  private selectDataSource(previous_data: any, current_data: any): any {
    return previous_data && Object.keys(previous_data).length > 0 ? previous_data : current_data;
  }
}
